import { create } from 'zustand';

interface ApiKeyStoreState {
    apiKey: string;
    baseUrl: string;
    instanceId: string;
    setApiKey: (apiKey: string) => void;
    setBaseUrl: () => void;
    setInstanceId: (instanceId: string) => void;
}

export const useApiKeyStore = 
    create<ApiKeyStoreState>(
        (set) => 
            ({
                apiKey: "MCAPUBK_TEST|1acf339a-d36f-47e7-8e1b-fd0b76b61b0c",
                baseUrl: 'https://staging.api.mycover.ai',
                instanceId: '',
                setApiKey: (apiKey) => set(() => ({ apiKey })),
                setBaseUrl: () => set((state) => ({ baseUrl: state.apiKey?.includes('TEST') ? 'https://staging.api.mycover.ai' : 'https://api.mycover.ai' })),
                setInstanceId: (instanceId) => set({ instanceId }), 
            })
        )
